export enum ShiftTypesEnum {
  'LEFT',
  'RIGHT'
}
